<template>
    <div class="min-h-screen flex flex-col bg-[#0F131D] theme_dark" @click.prevent="handleGlobalClick">
        <!--全局容器-->
        <el-container>
            <!--菜单栏-->
            <el-aside class="overflow-hidden! w-auto!">
                <!-- 菜单组件 -->
                <BaseMenu />
            </el-aside>
            <div class="flex flex-col flex-1">
                <!--顶部导航栏-->
                <Header />
                <!--主内容区-->
                <Main />
            </div>
        </el-container>
    </div>
</template>

<script setup lang="ts">
import BaseMenu from './components/BaseMenu.vue'
import Header from './components/BaseHeader.vue'
import Main from './components/BaseMain.vue'

import { useAppStore } from '@/stores'

const appStore = useAppStore()
const handleGlobalClick = () => {
    if (appStore.isMenuVisible) {
        appStore.isMenuVisible = false;
        appStore.isLoading = false
        appStore.isRouterAlive = true
    }
}
</script>
